module.exports = __webpack_public_path__ + "img/timeline_logo.2254335f.jpg";